import { Injectable } from '@angular/core';

export interface TipoNovedadSelectorPersistApi {
  prepararPersistenciaAntesDeAvanzarPaso(): void;
  obtenerEstadoActual(): Record<string, unknown> | null;
  sincronizarEstadoParaRadicar(): void;
  resetState(): void;
}

/**
 * Puente entre el padre (stepper) y el selector de tipo de novedad.
 * El componente hijo vive dentro de un ng-template del acordeón; ViewChild no siempre lo alcanza.
 */
@Injectable({ providedIn: 'root' })
export class TipoNovedadSelectorBridgeService {
  private api: TipoNovedadSelectorPersistApi | null = null;

  register(api: TipoNovedadSelectorPersistApi): void {
    this.api = api;
  }

  unregister(api: TipoNovedadSelectorPersistApi): void {
    if (this.api === api) {
      this.api = null;
    }
  }

  prepararAvanceDePaso(): void {
    this.api?.prepararPersistenciaAntesDeAvanzarPaso();
  }

  obtenerEstadoActual(): Record<string, unknown> | null {
    return this.api?.obtenerEstadoActual() ?? null;
  }

  sincronizarEstadoParaRadicar(): void {
    this.api?.sincronizarEstadoParaRadicar();
  }

  resetState(): void {
    this.api?.resetState();
  }
}
